<tt-page *ngIf="!!menu">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="equipmentgrp_id" [ttModel]="menu.equipmentgrp_id" ttReadonly></tt-input>
        <tt-input ttLabel="equipmentgrp_name" [ttModel]="menu.equipmentgrp_name" [ttButtons]="equipmentGroupNameButtons" ttReadonly></tt-input>
        <tt-button-goto [ttText]="'equipmentgrpmenu_edit'" [ttGoto]="'equipmentgrp'" [ttGotoParms]="{ equipmentgrp_id: menu.equipmentgrp_id }"></tt-button-goto>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-input class="col-xs-12 sp-0" tt-label="equipmentgrp_id" tt-model="vm.model.menu.equipmentgrp_id" tt-change="vm.model.menu.equipmentgrp_id = $value" tt-readonly="true"></tt-input>
        <tt-input-buttons class="col-xs-12 sp-0" tt-label="equipmentgrp_name" tt-model="vm.model.menu.equipmentgrp_name" tt-change="vm.model.menu.equipmentgrp_name = $value" tt-placeholder="" tt-buttons="vm.model.equipmentGroupNameButtons" tt-readonly="true"></tt-input-buttons>
        <tt-button-goto class="col-xs-12 sp-0" tt-text="equipmentgrpmenu_edit" tt-goto="equipmentgrp" tt-goto-parms="{ equipmentgrp_id: vm.model.menu.equipmentgrp_id }" tt-text-align="left"></tt-button-goto>
    </tt-card>
</tt-page>-->
